import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { MISSIONS_TYPES, MISSIONS_STATES } from '../constants/missionsInfo';
var generateTabs = function generateTabs(_ref) {
  var battlesAssets = _ref.battlesAssets,
    isOnMissions = _ref.isOnMissions,
    isOnBattles = _ref.isOnBattles,
    currentMissionType = _ref.currentMissionType;
  var explorerAsset = isOnMissions ? battlesAssets.BATTLES_TABS_EXPLORER_REGULAR : currentMissionType === MISSIONS_TYPES.BATTLES ? battlesAssets.BATTLES_TABS_EXPLORER_DISABLED : battlesAssets.BATTLES_TABS_EXPLORER_DOWN;
  var battlesAsset = isOnBattles ? battlesAssets.BATTLES_TABS_REGULAR : currentMissionType === MISSIONS_TYPES.EXPLORER ? battlesAssets.BATTLES_TABS_DISABLED : battlesAssets.BATTLES_TABS_DOWN;
  return [{
    TYPE: MISSIONS_TYPES.EXPLORER,
    TAB: explorerAsset
  }, {
    TYPE: MISSIONS_TYPES.BATTLES,
    TAB: battlesAsset
  }];
};
var generateTutorialInfoScreen = function generateTutorialInfoScreen(missionsAssets) {
  return [missionsAssets.TUTORIAL_INFO_SCREEN_POPUP_STEP_1, missionsAssets.TUTORIAL_INFO_SCREEN_POPUP_STEP_2, missionsAssets.TUTORIAL_INFO_SCREEN_POPUP_STEP_3];
};
var generateLayoutProgressbar = function generateLayoutProgressbar(missionsAssets) {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MISSIONS_STATES.COMPLETED, {
    LayoutBar: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_BASE_PURPLE,
    ShadowBar: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_SHADOW
  }), MISSIONS_STATES.FINISHED, {
    LayoutBar: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_BASE_PURPLE,
    ShadowBar: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_SHADOW
  }), MISSIONS_STATES.REWARD, {
    LayoutBar: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_COLLECT_BUTTON,
    ShadowBar: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_SHADOW
  }), MISSIONS_STATES.LOCKED, {
    LayoutBar: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_BASE_PURPLE,
    ShadowBar: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_SHADOW,
    IconLocked: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_LOCKED_ICON
  }), MISSIONS_STATES.READY, {
    IconReady: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_PLAY_ICON
  }), MISSIONS_STATES.RUNNING, {
    LayoutBar: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_BASE_BLUE,
    LayoutBarPurple: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_BASE_PURPLE,
    ShadowBar: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_SHADOW,
    FillBarStart: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_FILL_SIDE,
    FillBarProgess: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_FILL,
    FillBarEnd: missionsAssets === null || missionsAssets === void 0 ? void 0 : missionsAssets.BAR_FILL_SIDE
  });
};
export { generateTabs, generateTutorialInfoScreen, generateLayoutProgressbar };